module.exports = __webpack_public_path__ + "img/jaw.prt.18a2cb29.jpg";